import styled from 'styled-components';
import { maxDevice } from '~/styles/breakpoints';

export const Container = styled.div`
    flex: 1;

    align-self: stretch;
    display: flex;
    flex-direction: row;

    border-bottom: 2px solid #fff;

    margin: 30px 0 0;

    input {
        width: 100%;
        line-height: 51px;

        text-align: center;
        text-transform: uppercase;
        font-size: 3.6rem;
        color: #fff;

        border: 0;
        background: transparent;

        &::placeholder {
            color: rgba(255, 255, 255, 0.6);
        }

        transition: all 0.2s linear;
    }

    @media ${maxDevice.laptop} {
        margin-bottom: 30px !important;
    }
`;

export const SubmitButton = styled.button`
    width: 51px;
    height: 51px;

    border: 0;
    background: transparent;

    svg {
        font-size: 3.9rem;
        color: #fff;
    }
    transition: all 0.2s linear;
`;
